import { Component, Input } from '@angular/core';
import { VtmnPlayIconButtonSizeEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-size.enum';
import { VtmnPlayIconButtonVariantEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';

import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-navigation-tab-bar-navigation-button',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationTabBarNavigationButtonComponent {
  @Input() public href: string;
  @Input() public iconName: VtmnPlayIconTypeEnum;
  @Input() public isActive = false;
  @Input() public linkQueryParams: string;
  @Input() public linkRouter: string;
  @Input() public text: string;
  @Input() public totalNotifications = 0;

  public readonly vtmnPlayIconButtonVariant = VtmnPlayIconButtonVariantEnum;
  public readonly vtmnPlayIconButtonSize = VtmnPlayIconButtonSizeEnum;
}
